import { render } from "./SaveBettingForm.vue?vue&type=template&id=1b233999&scoped=true"
import script from "./SaveBettingForm.vue?vue&type=script&lang=js"
export * from "./SaveBettingForm.vue?vue&type=script&lang=js"

import "./SaveBettingForm.vue?vue&type=style&index=0&id=1b233999&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b233999"]])

export default __exports__